import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { Button } from "@mui/material"
import "./LogoutPopup.css"

const LogoutPopup = ({ isOpen, onClose, onConfirm, loading }) => {
  if (!isOpen) return null

  return (
    <div className="logout-overlay">
      <div className="logout-popup">
        <CheckCircleIcon className="logout-icon" />
        <h2 className="logout-title">Logout</h2>
        <p className="logout-message">Are you sure you want to Logout</p>
        <div className="logout-buttons">
          <Button variant="contained" className="logout-button yes-button" onClick={onConfirm}>
            {loading ? <span className="spinner"></span> : "Yes"}
          </Button>
          <Button variant="contained" className="logout-button no-button" onClick={onClose}>
            No
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LogoutPopup

